import {createTheme} from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#138ad3",
        },

        secondary: {
            main: "#00adfc",
        },

        text: {
            main: "#272727",
        },

        white: {
            main: "#ffffff"
        },

        gold: {
            main: "#FFC108"
        }
    },

    typography: {
        fontFamily: "Roboto",
    }
})

export default theme;